import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { FeatureFlagsList } from "@/components/feature-flags/feature-flags-list";
import { adminFeatureFlagsQueryKey } from "@/lib/admin-queries";
import { adminApi } from "@/lib/api";

function FeatureFlagsRoute() {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: adminFeatureFlagsQueryKey(),
    queryFn: () => adminApi.featureFlags.list(),
  });
  const mutation = useMutation({
    mutationFn: ({ name, enabled }: { name: string; enabled: boolean }) =>
      adminApi.featureFlags.setEnabled(name, enabled),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: adminFeatureFlagsQueryKey() }),
  });

  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="font-display text-2xl font-semibold tracking-tight">Przełączniki funkcji</h1>
        <p className="text-muted-foreground">
          Awaryjne kill-switche. Zmiana działa od razu, bez wdrożenia — włączony przełącznik wpływa
          na klientów.
        </p>
      </header>

      {query.isPending ? (
        <p className="text-sm text-muted-foreground">Ładowanie…</p>
      ) : query.isError ? (
        <p className="text-sm text-destructive">Nie udało się wczytać przełączników.</p>
      ) : (
        <FeatureFlagsList
          flags={query.data.flags}
          onToggle={async (name, enabled) => {
            await mutation.mutateAsync({ name, enabled });
          }}
        />
      )}
    </div>
  );
}

export const Route = createFileRoute("/feature-flags/")({ component: FeatureFlagsRoute });
